import * as React from 'react'
import { Form } from 'react-bootstrap'
import { Typography, Box, FormControl, RadioGroup, FormLabel, FormControlLabel, Radio } from '@mui/material'
import _ from 'lodash'

interface ValuationProps {
    value: string
    updateValue(value: string): void
}

const Valuation: React.FunctionComponent<ValuationProps> = (props): JSX.Element => {
    let [valuationOption, setValuationOption] = React.useState(null)

    // const [currentValue, setCurrentValue] = React.useState(null);
    const [lumpOption, setLumpOption] = React.useState(null)

    React.useEffect(() => {
        if (!_.isEqual(props.value, valuationOption)) {
            setValuationOption(props.value)
        }

    }, [props.value]);


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = (event.target as HTMLInputElement).value
        setValuationOption(value);
        props.updateValue(value)

    };

    // const handleLumpChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setLumpOption((event.target as HTMLInputElement).value);
    // };


    const renderItemsForLump = () => {
        return (
            <Box ml={5}>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="lumpOptions"

                        name="controlled-lump-radio-buttons-group"
                        value={valuationOption == "lump" ? null : valuationOption}
                        onChange={handleChange}
                    >
                        <FormControlLabel
                            value="lumpReplacement"
                            control={<Radio />}
                            label={<Typography>
                                <Typography component="span" fontWeight="bold">Replacement Cost Coverage with a $500 Deductible.</Typography>  (Declared value must be at least $3.50 times the weight of shipment.)
                            </Typography>} />
                        <FormControlLabel
                            value="lumpActual"
                            control={<Radio />}
                            label={<Typography>
                                <Typography component="span" fontWeight="bold">Actual Cost Coverage with a $500 Deductible.</Typography> (Declared value must be at least $3.50 times the weight of shipment.)
                            </Typography>} />

                    </RadioGroup>
                </FormControl>
            </Box>
        )
    }
    
    return (
        <Box mt={3}>
            <Typography variant="h4">Valuation</Typography>
            <FormControl component="fieldset">

                <RadioGroup
                    aria-label="gender"
                    name="controlled-radio-buttons-group"
                    value={(valuationOption == "lumpReplacement" || valuationOption == "lumpActual") ? "lump" : valuationOption}
                    onChange={handleChange}
                >
                    <FormControlLabel
                        value="basic"
                        control={<Radio />}
                        label={<Typography>
                            <Typography component="span" fontWeight="bold">Basic Value Protection.</Typography>  I release this shipment to a value of 60 cents per pound per article.
                        </Typography>} />
                    <FormControlLabel
                        value="depreciated"
                        control={<Radio />}
                        label={<Typography>
                            <Typography component="span" fontWeight="bold">Depreciated Value Protection.</Typography>  I release this shipment to a value of $2 per pound times the shipment weight.
                        </Typography>} />
                    <FormControlLabel
                        value="lump"
                        control={<Radio />}
                        label={<Typography>I declare a lump sum total ACV dollar valuation on this entire shipment of $TBD.</Typography>} />

                </RadioGroup>
            </FormControl>

            {(valuationOption == 'lump' || valuationOption == "lumpReplacement" || valuationOption == "lumpActual") && renderItemsForLump()}
        </Box>
    )
}

export default Valuation